import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectPageType } from '../selectors/page';
import { subscribeToLocationChange } from '../utils/locationChange';

function getIsMainPage(): boolean {
  return window.location.pathname === '/' && !window.location.hostname.startsWith('my.');
}

export function useIsMainPage(): boolean {
  const pageType = useSelector(selectPageType);
  // SSR and the first client render must use the same source of truth.
  const [isMainPage, setIsMainPage] = useState(() => pageType === 'main');

  useEffect(() => {
    const update = () => setIsMainPage(getIsMainPage());

    return subscribeToLocationChange(update);
  }, []);

  return isMainPage;
}
